/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationCustomerGranteesQuery = gql`
  query GetSimulationCustomerGranteesQuery {
    getSimulationCustomerGrantees_simulation_customer_grantees {
      offer {
 effectDate  
}
      jobs {
 caisse  
label  
value  
}
      customer {
 civility  
firstName  
lastName  
birthDate  
addresses {
 fields  
city  
zipCode  
country  
} 
socialSecurities {
 regime  
isCSS  
dateCSS  
number  
twinsRank  
} 
CSPs {
 label  
externalId  
categoryCSPExternalId  
categoryLvl1CSPExternalId  
categoryLvl1Label  
} 
isTNS  
emails {
 value  
} 
phones {
 internationalCode  
number  
isMobile  
} 
finances {
 annualIncome  
} 
professionalStatus  
GDPR {
 email  
phone  
company  
partners  
} 
salesArea {
 country  
} 
}
      grantees {
 id  
civility  
type  
firstName  
lastName  
birthDate  
socialSecurities {
 regime  
number  
twinsRank  
} 
CSPs {
 label  
externalId  
categoryCSPExternalId  
categoryLvl1CSPExternalId  
categoryLvl1Label  
} 
isTNS  
}
      beclmBlocked 
      cfeContributionsPaidByRepresentative 
      company {
 creationDate  
}
    }
  }
`;

export default GetSimulationCustomerGranteesQuery;
